import { render, staticRenderFns } from "./LogoBar.vue?vue&type=template&id=244c049f&scoped=true"
import script from "./LogoBar.vue?vue&type=script&lang=js"
export * from "./LogoBar.vue?vue&type=script&lang=js"
import style0 from "./LogoBar.vue?vue&type=style&index=0&id=244c049f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c049f",
  null
  
)

export default component.exports